import React from 'react'
import { Field, change, getFormValues } from 'redux-form'
import { connect } from 'react-redux'
import { Button, Icon, Popup } from 'semantic-ui-react'

import { StdCard } from 'components'
import FieldInput, { InputType as type } from 'components/SemanticForm'

import { 
  RowHeader,
  RowHeader_,
  RowData_,
  RowData,
  RowNF
} from './styled'
import { TrendingUpOutlined } from '@material-ui/icons'

const PaymentCondition = (props) => {
  const {
    isEdit = false,
    isCreate = false,
    isDetail = false,
    valueForm,
    dispatch
  } = props

  return (
    <StdCard title='Payment Condition' style={{ marginTop: '10px' }}>
      <React.Fragment>
        {!isDetail&&<Button 
          type='button'
          content='Add' 
          color='green'
          icon='plus' 
          labelPosition='right'
          style={{ marginRight: '5px' }}
          onClick={()=>{
            dispatch(change('formContract',`paymentConditions[${valueForm.paymentConditions.length}].lineNo`,valueForm.paymentConditions.filter(x=>x.deleted!=true).length+1))
          }}
        />}
        <div style={{height:'1rem'}}/>
        <div style={{display:'flex', flexDirection:'column'}}>
          <div style={{display:'flex'}}>
            <RowHeader_ style={{width:'13rem'}}>No.</RowHeader_>
            <RowHeader style={{width:'100rem'}}>Installment{' '}<span style={{color:'red'}}>*</span></RowHeader>
            <RowHeader>Installment Payment{' '}<span style={{color:'red'}}>*</span></RowHeader>
            <RowHeader>Remark</RowHeader>
            {isDetail?null:
            <RowHeader style={{width:'13rem'}}>Action</RowHeader>}
          </div>
          {valueForm&&valueForm.paymentConditions.length?
          valueForm.paymentConditions.map((con, index) => {
            return !con.deleted&&
            <div style={{display:'flex'}}>
              <RowData_ style={{width:'13rem'}}>
                <Field 
                  name={`paymentConditions[${index}].lineNo`} 
                  type={type.text}
                  editable={false}
                  component={FieldInput}
                />
              </RowData_>
              {isDetail?
                <Popup 
                  content={valueForm&&valueForm.paymentConditions[index].installment} 
                  trigger={
                    <RowData style={{width:'100rem'}}>
                      <Field 
                        name={`paymentConditions[${index}].installment`}  
                        type={type.text}
                        editable={!isDetail}
                        component={FieldInput}
                        placeHolder='ระบุงวดการส่งมอบงาน เช่น งวดที่ 1 หรือ 30%'
                      />
                    </RowData>
                  } 
                />
              :
              <RowData style={{width:'100rem'}}>
                <Field 
                  name={`paymentConditions[${index}].installment`}  
                  type={type.text}
                  editable={!isDetail}
                  component={FieldInput}
                  placeHolder='ระบุงวดการส่งมอบงาน เช่น งวดที่ 1 หรือ 30%'
                />
              </RowData>
              }
              <RowData>
                <Field 
                  name={`paymentConditions[${index}].installmentPayment`}  
                  type={type.number}
                  component={FieldInput}
                  editable={!isDetail}
                  fixedDecimalScale={true}
                  decimalScale={2}
                  placeholder='ระบุจำนวนเงินเป็นตัวเลข เช่น 3,000,000'
                />
              </RowData>
              <RowData>
                <Field 
                  name={`paymentConditions[${index}].remark`}  
                  type={type.textArea}
                  editable={!isDetail}
                  component={FieldInput}
                />
              </RowData>
              {isDetail?null:
              <RowData style={{width:'13rem'}}>
                <Icon circular name='trash alternate' color='red' link 
                  onClick={()=>{
                    // dispatch(change('formContract',`paymentConditions[${index}].deleted`, true))
                    let clone2 = JSON.parse(JSON.stringify(valueForm.paymentConditions))
                    // clone2.splice(index,1)
                    clone2[index].deleted = true
                    let c = 0
                    dispatch(change('formContract','paymentConditions',clone2.map((x,i)=>{
                      return(
                        {...x,lineNo:x.deleted?x.lineNo:c+=1}
                      )
                    })))
                  }}
                />
              </RowData>}
            </div>
          })
          :
          <RowNF>Payment Condition not found</RowNF>
          }
        </div>
      </React.Fragment>
    </StdCard>
  )
}
const mapStateToProps = (state, props) => {
  return ({
    valueForm: getFormValues('formContract')(state),
  })
}

const mapDispatchToProps = (dispatch) => ({
  dispatch
})


export default connect(mapStateToProps, mapDispatchToProps)(PaymentCondition)